import React from 'react';
import styled from 'styled-components';

import { Futura } from '~/styles';
import { media } from '~/utils';

export default function ({ org, large = false, onClick }) {
  const fontSize = org.vision.length <= 30 ? 40 : org.vision.length <= 42 ? 30 : 25;

  return (
    <Wrapper large={large}>
      <Title>ビジョン</Title>
      <Text large={large} fontSize={fontSize}>
        {org.vision}
      </Text>
      {!large && <SeeMore onClick={onClick}>SEE MORE</SeeMore>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;

  ${media.mid`
    border-radius: 0;
  `}
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Text = styled.div`
  margin-top: 15px;
  padding: 0 35px;
  padding-bottom: 60px;
  font-size: ${(props) => (props.large ? '40' : props.fontSize)}px;
  font-weight: bold;
  line-height: 50px;
  overflow: hidden;
`;

const SeeMore = styled(Futura)`
  position: absolute;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  z-index: 1;
  left: 35px;
  bottom: 10px;
`;
